import { MedicationLotContext } from './MedicationLotSuggestions';
import { CombinedDyadEntry } from './CombinedDyadEntry';
import { BirthMonitoring } from './BirthMonitoring';
import { useEffect, useState } from 'react';
import { LaborFlowsheet, type BirthWorkspaceProps } from './LaborFlowsheet';
import { BirthDischarge } from './BirthDischarge';
import { PostpartumDyad } from './PostpartumDyad';
import { withNewbornSubjects } from './newbornSubjects';
import type { ClinicalEpisode } from './types';
export function BirthWorkspace(props: BirthWorkspaceProps) {
  const [augmented, setAugmented] = useState<ClinicalEpisode>();
  useEffect(() => {
    let valid = true;
    void withNewbornSubjects(props.episode).then((e) => {
      if (valid) setAugmented(e);
    });
    return () => {
      valid = false;
    };
  }, [props.episode]);
  if (!augmented || augmented.id !== props.episode.id) return <p>Preparing subject identities…</p>;
  return (
    <MedicationLotContext.Provider value={{ lookup: props.lookupMedicationLots, events: props.events }}>
      <div className="flex flex-col gap-4">
        <BirthMonitoring {...props} episode={augmented} />
        <LaborFlowsheet {...props} episode={augmented} />
        <CombinedDyadEntry {...props} episode={augmented} />
        <PostpartumDyad
          {...props}
          episode={augmented}
          pendingBirths={props.pendingEntries?.filter(
            (e) =>
              e.event_type === 'BIRTH' && ['pending', 'retryable-error', 'sign-in-required'].includes(e.pendingState),
          )}
        />
        <BirthDischarge {...props} episode={augmented} />
      </div>
    </MedicationLotContext.Provider>
  );
}
